import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SelectList } from '../models/selectlist';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class CombosService extends BaseService {

  constructor(private http: HttpClient) {super(); }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    }),
  };

  preencheCombos(name: string, codigo: string = ''): Observable<SelectList[]>{
    const url = `${this.UrlService}Combo/?n=` + name + '&c=' + codigo;
    return this.http.get<SelectList[]>(url, this.httpOptions);
  }

  getCotista() {
    return [
      { codigo: '1', descricao: 'CI' },
      { codigo: '2', descricao: 'CII' },
      { codigo: '3', descricao: 'CIII' }
    ];
  };

  getSexo() {
    return [
      { codigo: 'M', descricao: 'Masculino' },
      { codigo: 'F', descricao: 'Feminino' }
    ];
  };

  getEscrita() {
    return [
      { codigo: 'D', descricao: 'Destro' },
      { codigo: 'C', descricao: 'Canhoto' }
    ];
  };

  getCienciaConcurso() {
    return [
      { codigo: '1', descricao: 'Site do TJ' },
      { codigo: '2', descricao: 'Jornal' },
      { codigo: '3', descricao: 'Site da EMERJ' },
      { codigo: '4', descricao: 'Outros' }
    ];
  };

  getNecessEspecial() {
    return [
      { codigo: 'NAO', descricao: 'Não' },
      { codigo: 'SIM', descricao: 'Sim' }
    ];
  };

  getIsentoIR() {
    return [
      { codigo: 'N', descricao: 'Não' },
      { codigo: 'S', descricao: 'Sim' }
    ];
  };

  getDesempregado() {
    return [
      { codigo: 'N', descricao: 'Não' },
      { codigo: 'S', descricao: 'Sim' }
    ];
  };

}
